function getConfig(config: any): any {
    if (typeof config === 'string') {
        try {
            config = JSON.parse(config);
        } catch (error) {
            console.log(error.message);
        }
    }

    return config || {};
}

function getConfigItem(
    report: { data: any[], standort: number, key: string, sub?: string },
    callback?: (data: any, config: any, index: number) => void
): any {
    const config: any = getCurrentConfig(report.data) || null;
    const selection: any[] = (config || {}).selection || [];
    const index: number = selection.findIndex((item: any) =>
        item.standort === (+report.standort || 0) && item.key === report.key && (item.sub || null) === (report.sub || null)
    );

    if (typeof callback === 'function') {
        callback(selection[index] || null, config, index !== -1 ? index : null);
        return;
    }

    return selection[index] || null;
}

export function getCurrentConfig(data: any[], prepare: boolean = true, callback?: (data: any, index: number) => void): any {
    const configs: any[] = (prepare ? getReportConfigs(data) : data) || [];
    let curIndex: number = configs.length === 1 ? 0 : null

    if (curIndex === null) {
        curIndex = configs.indexOf(configs.reduce((maxItem: any, curItem) =>
            curItem.tid > maxItem.tid ? curItem : maxItem, { tid: null }
        ));
    }

    if (typeof callback === 'function') {
        callback(configs[curIndex] || null, curIndex);
        return;
    }

    return configs[curIndex] || null;
}

export function getReportConfigItem(
    report: { data: any[], standort: number, key: string, sub?: string },
    callback?: (data: any, config: any, index: number) => void
): any {
    if (!Array.isArray(report.data) || typeof report.key !== 'string') {
        return null;
    }

    if (typeof callback === 'function') {
        getConfigItem(report, (data: any, config: any, index: number) => callback(data, config, index));
        return;
    }

    return getConfigItem(report) || null;
}

export function getReportConfig(data: any[]): any {
    if (!(data || []).length) {
        return null;
    }

    return getCurrentConfig(data) || null;
}

export function getReportConfigs(data: any[]): any[] {
    if (!(data || []).length) {
        return null;
    }

    return data.map((data: any) =>
        ({ ...(getConfig(data.konfiguration || null) || {}), tid: data.tid || null, name: data.name || null })
    );
}
